import React, { Fragment } from 'react';
import SubLinksHeader from './sublinks-header';
import SubLinks from '../../common/sub-links';
import { INavlinksProps } from '../../IFooter';
import { IMainNavigation, ILinks } from '../../common/ICommon';

const Navlinks = ({ navlinks, disclaimer, section }: INavlinksProps): JSX.Element => {
  return (
    <div className="w-full flex flex-col">
      <div className="flex flex-row">
        {navlinks?.map((ele: IMainNavigation, key: number) => {
          const menus = ele?.subLinks;
          return (
            <div className="flex-1" key={`ft-dt-hdr-${key}`}>
              {section != "bottom" && <SubLinksHeader navigationHeader={ele.navigationHeader} key={`ft-dt-snh-${key}`} />}
              <div className="flex-none text-base" role="list">
                {menus?.map((item: ILinks, index: number) => {
                  return (
                    <div key={`ft-dt-sls-${index}`}>
                      <SubLinks items={item} index={index} listCount={menus.length} />
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Navlinks;
